import { SVGProps } from 'react'

export const KotlinIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={15}
    height={15}
    viewBox="0 0 500 500"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <linearGradient
        id="kotlin_icon_with_gradient"
        x1="500.0035"
        y1="579.1058"
        x2="-9.653803e-02"
        y2="1079.2058"
        gradientTransform="matrix(0.9998 0 0 0.9998 9.651873e-02 -578.99)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00343514" stopColor="#E44857" />
        <stop offset="0.4689" stopColor="#C711E1" />
        <stop offset="1" stopColor="#7F52FF" />
      </linearGradient>
      <polygon
        points="500,500 0,500 0,0 500,0 250,250 		"
        fill="url(#kotlin_icon_with_gradient)"
      />
    </g>
  </svg>
)
